/* **************************************************** Finishing Shedule File List */
export interface FSFileList {
    index: number;
    extension: string;
    file_path: string;
}

export const mapFSFileList = (data: any): FSFileList => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSFileList = {
        index: data.index,
        extension: data.extension,
        file_path: data.file_path,
    };

    return res;
};

export const mapFSFileLists = (data: any[]): FSFileList[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSFileList);
};
